exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ArrowButton_button-text_3cSX {\n  margin-left: -8px;\n}\n\n.ArrowButton_arrow_4_YC {\n  margin-right: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"button-text": "ArrowButton_button-text_3cSX",
	"arrow": "ArrowButton_arrow_4_YC"
};